/**
 * 全局 console.log 控制
 * - production: 静默所有 console.log（terser 构建时 drop_console 也会移除）
 * - development: 保持原样
 * - testenv: 默认开启，在浏览器控制台输入 window.log = false 关闭
 */

const MODE = import.meta.env.MODE
const originalLog = console.log.bind(console)
const noop = (..._args: any[]) => {}

// 测试环境：通过 window.log 控制开关
if (MODE === 'testenv') {
  let _logEnabled = true

  // 默认开启 console.log
  console.log = originalLog

  // 定义 window.log 属性用于开关控制
  Object.defineProperty(window, 'log', {
    configurable: true,
    enumerable: true,
    get() {
      return _logEnabled
    },
    set(val: boolean) {
      _logEnabled = !!val
      console.log = _logEnabled ? originalLog : noop
    },
  })
} else if (MODE === 'production') {
  // 生产环境兜底关闭（构建时 terser drop_console 已处理）
  console.log = noop
}
// development 环境不做任何处理，保持原样
